import { call, put } from 'redux-saga/effects';
import {
  changeStatusAfterUpdate,
  fetchActivityLogsRequest,
  submitHmrcReturnFailure,
  submitHmrcReturnSuccess,
} from '../actions';
import { ApiError, ApiResponse } from 'store/api/types';
import { SubmitHmrcReturnRequestAction } from '../types';
import { checkResponse } from 'store/utils';
import { submitHmrcReturn } from '../api';
import { turnMessageOn } from 'store/app/actions';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';
import { DataLogStatus, SubmissionUpdateField } from 'store/app/enums';
import { updateSubmissionLog } from 'store/organisation/actions';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* submitHmrcReturnSaga(action: SubmitHmrcReturnRequestAction) {
  try {
    let err: ApiError | null;
    const { dataLogId, mappingId, hmrcSubmissionRequest } = action.payload;
    const response: ApiResponse = yield call(
      submitHmrcReturn,
      dataLogId,
      mappingId,
      hmrcSubmissionRequest
    );
    err = checkResponse(response?.responseMessage);
    if (err) throw err;
    const message: MessageData = {
      title: i18n.t('common.success-exclamation'),
      description: response.responseMessage.message,
      type: MessageStates.SUCCESS,
    };
    yield put(turnMessageOn(message));
    yield put(fetchActivityLogsRequest(dataLogId));
    yield put(changeStatusAfterUpdate(DataLogStatus.SUBMITTED));

    yield put(submitHmrcReturnSuccess());
    yield put(
      updateSubmissionLog(
        mappingId,
        SubmissionUpdateField.STATUS,
        DataLogStatus.SUBMITTED,
        dataLogId
      )
    );
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(submitHmrcReturnFailure());
  }
}
